import { atom } from "jotai";
import { ComposerContextType } from "@zapier/agent-system";
import { emitEventOnExecuteZslSetter } from "../events";
import { templateSlugAtom } from "./templateSlugAtom";
import { executeZslAndSaveSetter } from "./executeZslAndSaveSetter";

export const handleUseTemplateSetter = atom(
  null,
  async (get, set, composerService: NonNullable<ComposerContextType>) => {
    const templateSlug = get(templateSlugAtom);

    if (templateSlug) {
      set(emitEventOnExecuteZslSetter, templateSlug);
    }

    await set(executeZslAndSaveSetter, { composerService });
  },
);

handleUseTemplateSetter.debugLabel = "handleUseTemplateSetter";
